import React, {Component} from 'react';
import './index.scss';
import logo from '../../assets/logo.png'
import {Button, Card, Divider, Icon, Spin} from 'antd';
import UserRepo from '../../repository/user';
import {Redirect} from 'react-router-dom';
import {subscribe} from 'alfa';

class LoginIndex extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      urlInfo: null,
    }
  }

  getAuthURL() {
    UserRepo.authURL().then(
      result => {
        const data = result.data
        localStorage.setItem("authseed", data.seed)
        this.setState({
          loading: false,
          urlInfo: data,
        })
      },
    )
  }

  renderLoading() {
    return <Spin />
  }

  renderForm() {
    return (
      <Card
        className="login-card"
        cover={<img alt="lana" src={logo} style={{width: 388}} />}
      >
        <Card.Meta title="Welcome to Lana B2B Admin" description="To get started, you need to login with your lana account." />
        <Divider />
        <Button type="primary" block  onClick={() => window.location = this.state.urlInfo.url}>
          <Icon type="google" /> Login with Google
        </Button>
      </Card>
    )
  }

  render() {
    const data = localStorage.getItem('user');

    if (data) {
      if (!this.props.user) {
        this.props.set('user', JSON.parse(data));
      }
      const { from } = this.props.location.state || { from: { pathname: '/' } };
      return <Redirect to={from} />
    }

    if (this.state.loading) {
      this.getAuthURL();
      return this.renderLoading();
    }

    return this.renderForm();
  }
}

export default subscribe(LoginIndex, ['set', 'user'], ['user']);